import { NavigateFunction } from "react-router";
import { RegistrationRoute } from "../../../apps/registration/routes/route";
import { Base64Util } from "../../utils/base64";
import Tokens from "../../utils/storage/tokens";
import { RedirectQueryParam } from "../../enums/Redirect";
import QueryParamKey from "../../enums/QueryParamKey";
import { UseMutateAsyncFunction } from "react-query";
import IFrameQueryParam from "shared/enums/IFrameQueryParam";

export function redirectToRegResumeFlow(navigate: NavigateFunction, searchParams: URLSearchParams) {
  const regParticipantId = searchParams.get(RedirectQueryParam.REGISTRATION_PARTICIPANT_ID);
  const token = searchParams.get(RedirectQueryParam.TOKEN);
  Tokens.setTransitToken(token || "");
  searchParams.delete(RedirectQueryParam.REGISTRATION_PARTICIPANT_ID);
  searchParams.delete(RedirectQueryParam.TOKEN);
  searchParams.delete(RedirectQueryParam.ROUTE);
  searchParams.append(QueryParamKey.REG_PARTICIPATION_ID, Base64Util.encode(regParticipantId || "") as string);
  navigate({
    pathname: RegistrationRoute.InitiateReg,
    search: `?${searchParams.toString()}`
  });
}

export async function redirectToStripeIntermediatePage(
  searchParams: URLSearchParams,
  makeStripePayment: UseMutateAsyncFunction<any, any, any, unknown>,
  paymentSuccessCallback?: (searchParams: URLSearchParams) => void
) {
  const registrationParticipantId = Base64Util.decode(searchParams.get(QueryParamKey.REG_PARTICIPATION_ID));
  const purchaseOrderId = searchParams.get(RedirectQueryParam.PURCHASE_ORDER_ID);
  const stripeToken = searchParams.get(RedirectQueryParam.STRIPE_PAYMENT_INTENT_ID);
  const amount = searchParams.get(RedirectQueryParam.AMOUNT_OBJECT);
  const uiVersion = searchParams.get(RedirectQueryParam.REG_PARTICIPAN_UI_VERSION);
  const reqObj = {
    registrationParticipantId,
    purchaseOrderId,
    token: stripeToken,
    amount: JSON.parse(amount as string),
    uiVersion
  };
  try {
    await makeStripePayment(reqObj);
    const navigateToUrl = new URL(window.location.href);
    stripOffStripeRelatedParams(navigateToUrl.searchParams);
    navigateToUrl.searchParams.delete(IFrameQueryParam.IFRAME_PARENT_URL);
    paymentSuccessCallback?.(navigateToUrl.searchParams);
  } catch (e) {}
}

export function redirectToRegPaymentResumeFlow(navigate: NavigateFunction, searchParam: URLSearchParams) {
  const invoicePaymentRequestId = searchParam.get(RedirectQueryParam.INVOICE_PAYMENT_REQUEST_ID);
  const invoicePayerId = searchParam.get(RedirectQueryParam.INVOICE_PAYER_ID);
  const token = searchParam.get(RedirectQueryParam.TOKEN);
  Tokens.setTransitToken(token ?? "");
  const encodedInvoicePaymentRequestId = Base64Util.encode(invoicePaymentRequestId ?? "");
  const encodedInvoicePayerId = Base64Util.encode(invoicePayerId ?? "");
  navigate({
    pathname: RegistrationRoute.Payment,
    search: `?${QueryParamKey.INVOICE_PAYMENT_REQUEST_ID}=${encodedInvoicePaymentRequestId}&${QueryParamKey.INVOICE_PAYER_ID}=${encodedInvoicePayerId}`
  });
}

export function redirectToTicketForm(navigate: NavigateFunction, searchParams: URLSearchParams) {
  stripOffStripeRelatedParams(searchParams);
  searchParams.set(
    RedirectQueryParam.REGISTRATION_PARTICIPANT_ID,
    Base64Util.decode(searchParams.get(QueryParamKey.REG_PARTICIPATION_ID)) as string
  );
  searchParams.set(RedirectQueryParam.TOKEN, Tokens.getTransitToken());
  searchParams.delete(QueryParamKey.REG_PARTICIPATION_ID);
  redirectToRegResumeFlow(navigate, searchParams);
}

// this will strip off all the query params that were added for stripe redirect handling
function stripOffStripeRelatedParams(searchParams: URLSearchParams) {
  // no need to return since updating the original object
  searchParams.delete(RedirectQueryParam.STRIPE_REDIRECT_STATUS);
  searchParams.delete(RedirectQueryParam.STRIPE_PAYMENT_INTENT_ID);
  searchParams.delete(RedirectQueryParam.STRIPE_PAYMENT_CLIENT_SECRET);
  searchParams.delete(RedirectQueryParam.STRIPE_SOURCE_TYPE);
  searchParams.delete(RedirectQueryParam.ROUTE);
  searchParams.delete(RedirectQueryParam.PURCHASE_ORDER_ID);
  searchParams.delete(RedirectQueryParam.REG_PARTICIPAN_UI_VERSION);
  searchParams.delete(RedirectQueryParam.AMOUNT_OBJECT);
}
